import * as React from "react"

import { cn } from "../../lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border-2 border-neutral300 dark:border-neutral600 bg-white dark:bg-neutral800 px-3 py-2 text-base text-neutral900 dark:text-neutral100 shadow-sm placeholder:text-neutral400 dark:placeholder:text-neutral500 focus-visible:outline-none focus-visible:border-sumoPrimary focus-visible:ring-4 focus-visible:ring-sumoPrimary/10 disabled:cursor-not-allowed disabled:bg-neutral100 dark:disabled:bg-neutral700 disabled:opacity-60 hover:border-neutral400 dark:hover:border-neutral500 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
